import React, { useState, forwardRef  } from 'react';

const CareerSection = forwardRef((props, ref) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    position: "",
    salary: "",
    location: "",
    visaStatus: "",
    animal: "",
    description: "",
    leavingReason: "",
    whyCandidate: "",
    weaknesses: "",
    whatCanYouDo: "",
    resumeSummary: "",
    resumeFile: "",
    passportPicture: "",
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'file' ? files[0] : value,
    }));
  };
  let apiUrl = process.env.REACT_APP_API_URL;
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
  
    for (const key in formData) {
      data.append(key, formData[key]);
    }
  
    try {
      const response = await fetch(`${apiUrl}/api/send-email`, {
        method: 'POST',
        body: data,  // ❌ Removed `Content-Type`, let browser set it
      });
  
      if (response.ok) {
        alert('Form submitted and email sent successfully!');
      } else {
        alert('Error sending email. Please try again.');
      }
      //  Optionally reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        position: "",
        salary: "",
        location: "",
        visaStatus: "",
        animal: "",
        description: "",
        leavingReason: "",
        whyCandidate: "",
        weaknesses: "",
        whatCanYouDo: "",
        resumeSummary: "",
        resumeFile: "",
        passportPicture: "",
      });
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };
  
  return (
    <>
      <section
        id="career"
        ref={ref}
        className="max-w-6xl mx-3 md:mx-7 lg:mx-auto my-20 md:my-32 px-2 sw-two py-12 rounded-xl"
      >
        <h2 className="text-3xl md:text-4xl font-bold md:my-4 text-center">
          Submit Your Resume
        </h2>
        <form
          id="contact-form"
          className="py-6 px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 font-medium"
          onSubmit={handleSubmit}
        >
          {/* Name */}
          <div>
            <label className="label">
              <span className="label-text">Name</span>
            </label>
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none pt-2 text-base"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          {/* Email */}
          <div>
            <label className="label">
              <span className="label-text">Email</span>
            </label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none pt-2"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          {/* Phone */}
          <div>
            <label className="label">
              <span className="label-text">Phone Number</span>
            </label>
            <input
              type="number"
              name="phone"
              placeholder="Enter your phone number"
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none pt-2"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          {/* Position Apply For */}
          <div>
            <label className="label">
              <span className="label-text">Position Apply For</span>
            </label>
            <input
              type="text"
              name="position"
              placeholder="Position name"
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none pt-2 text-base"
              value={formData.position}
              onChange={handleChange}
              required
            />
          </div>
          {/* What is your Salary expectations? */}
          <div>
            <label className="label">
              <span className="label-text">What is your salary expectations?</span>
            </label>
            <input
              type="number"
              name="salary"
              placeholder="What is your salary expectations?"
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none pt-2"
              value={formData.salary}
              onChange={handleChange}
              required
            />
          </div>
          {/* Preferred Job Location */}
          <div>
            <label className="label">
              <span className="label-text">Preferred Job Location</span>
            </label>
            <select
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none"
              name="location"
              value={formData.location}
              onChange={handleChange}
              required
            >
              <option value="" disabled>Please choose an option</option> {/* Use value="" for the default option */}
              <option value="Qatar">Qatar</option>
              <option value="India">India</option>
              <option value="UAE">UAE</option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Canada">Canada</option>
            </select>
          </div>
          {/* Visa Status */}
          <div>
            <label className="label">
              <span className="label-text">Visa Status</span>
            </label>
            <select
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none"
              name="visaStatus"
              value={formData.visaStatus}
              onChange={handleChange}
              required
            >
              <option value="" disabled>Please choose an option</option> {/* Same here */}
              <option value="Employment">Employment</option>
              <option value="Spouse">Spouse</option>
              <option value="Visit">Visit</option>
              <option value="Student">Student</option>
              <option value="Citizenship">Citizenship</option>
              <option value="Parent sponsor">Parent sponsor</option>
            </select>
          </div>
          {/* If you are an animal, which would you want to be? */}
          <div>
            <label className="label">
              <span className="label-text">If you are an animal, which would you want to be?</span>
            </label>
            <input
              type="text"
              name="animal"
              placeholder="Animal which matches your personality"
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none pt-2"
              value={formData.animal}
              onChange={handleChange}
              required
            />
          </div>
          {/* Description Or Cover Letter */}
          <div>
            <label className="label">
              <span className="label-text">Description Or Cover Letter</span>
            </label>
            <textarea
              name="description"
              rows="1"
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none pt-2"
              placeholder="Description"
              value={formData.description}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          {/* Why are you leaving your current job? */}
          <div>
            <label className="label">
              <span className="label-text">Why are you leaving your current job?</span>
            </label>
            <textarea
              rows="1"
              name="leavingReason"
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none pt-2"
              placeholder="Reason?"
              value={formData.leavingReason}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          {/* Why are you the right candidate for this job? */}
          <div>
            <label className="label">
              <span className="label-text">Why are you the right candidate for this job?</span>
            </label>
            <textarea
              name="whyCandidate"
              rows="1"
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none pt-2"
              placeholder="Explain?"
              value={formData.whyCandidate}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          {/* What are your weaknesses? */}
          <div>
            <label className="label">
              <span className="label-text">What are your weaknesses?</span>
            </label>
            <textarea
              name="weaknesses"
              rows="1"
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none pt-2"
              placeholder="Weaknesses?"
              value={formData.weaknesses}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          {/* What can you do? */}
          <div>
            <label className="label">
              <span className="label-text">What can you do?</span>
            </label>
            <textarea
              name="whatCanYouDo"
              rows="1"
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none pt-2"
              placeholder="Share"
              value={formData.whatCanYouDo}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          {/* Brief Summary about your Resume */}
          <div>
            <label className="label">
              <span className="label-text">Brief Summary about your Resume</span>
            </label>
            <textarea
              name="resumeSummary"
              rows="1"
              className="text-base w-full h-10 border border-info px-3 rounded-lg outline-none pt-2"
              placeholder="Share"
              value={formData.resumeSummary}
              onChange={handleChange}
              required
            ></textarea>
          </div>
             {/* Attach Resume File */}
            <div>
               <label className="label">
                 <span className="label-text">Attach Resume File</span>
               </label>
               <input
                 type="file"
                 name='resumeFile'
                 className="file-input file-input-bordered file-input-info w-full h-10"
                 onChange={handleChange}
               />
             </div>
             {/* Upload your Passport size picture */}
             <div>
               <label className="label">
                 <span className="label-text">Upload your Passport size picture.</span>
               </label>
               <input
                 type="file"
                 name='passportPicture'
                 className="file-input file-input-bordered file-input-info w-full h-10"
                 onChange={handleChange}
              />
             </div>
             {/* Success Message */}
             <div className="md:col-span-2 lg:col-span-4 flex justify-center">
               <p
                 id="toast"
                 className="duration-500 py-1.5 px-4 bg-green-400 text-white rounded-md opacity-0 absolute"
               >
                 <i className="fa-regular fa-circle-check"></i> Career form submitted
                 successfully
               </p>
             </div>
             {/* Submit Button */}
             <div className="md:col-span-2 lg:col-span-4 flex justify-center">
               <button type='submit' className="btn btn-info text-white text-xl px-14 mt-4">
                 <span id="btnText">Submit</span>
                 <img
                   id="btnImg"
                   className="h-8 hidden"
                   src="image/spiner.gif"
                   alt=""
                 />
               </button>
             </div>
        </form>
      </section>
    </>
  );
});

export default CareerSection;
